/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedHealthcareFacilityList } from '../models/PaginatedHealthcareFacilityList';
import type { SimpleHealthcareFacility } from '../models/SimpleHealthcareFacility';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class HealthcareEntityService {

    /**
     * @returns PaginatedHealthcareFacilityList
     * @throws ApiError
     */
    public static healthcareEntityFacilitiesList({
        healthcareEntity,
        limit,
        notProvider,
        offset,
        ordering,
        provider,
        rep,
    }: {
        healthcareEntity?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        notProvider?: string,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: string,
        rep?: string,
    }): CancelablePromise<PaginatedHealthcareFacilityList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/healthcare_entity/facilities',
            query: {
                'healthcare_entity': healthcareEntity,
                'limit': limit,
                'not_provider': notProvider,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'rep': rep,
            },
        });
    }

    /**
     * @returns SimpleHealthcareFacility
     * @throws ApiError
     */
    public static healthcareEntityFacilitiesCreate({
        requestBody,
    }: {
        requestBody: SimpleHealthcareFacility,
    }): CancelablePromise<SimpleHealthcareFacility> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/healthcare_entity/facilities',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get Provider Information for a Healthcare Organization
     * @returns any
     * @throws ApiError
     */
    public static healthcareEntityMarketplaceProviderRetrieve({
        provider,
    }: {
        provider: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/healthcare_entity/marketplace-provider/{provider}/',
            path: {
                'provider': provider,
            },
        });
    }

}
